import { useState, useEffect, useMemo } from 'react';
import { Col, Row } from 'antd';
import { Helmet } from 'react-helmet';
import MultinationalTabs from '../../../../../../components/MultinationalTabs';
import { useDispatch, useSelector } from 'react-redux';
import {
    getPushDrivers,
    allPushDrivers,
} from '../../../../../../redux/slices/settingsSlice';
import {
    oneClient,
    // updateClientDrivers,
    getClient,
    clientDataStore,
} from '../../../../../../redux/slices/clientsSlice';
import PushTypeDriverInputs from './PushTypeDriverInputs';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { countriesOptions } from '../../../../../../shared/data/clientDetailsOptions';

export default function PushTypePage() {
    const dispatch = useDispatch();
    const params = useParams();
    const pushDrivers = useSelector(allPushDrivers);
    const client = useSelector(oneClient);
    const dataStore = useSelector(clientDataStore);

    const countriesLocalizationsData = useMemo(
        () =>
            client?.countries_localizations?.reduce((acc, el) => {
                acc[el.country_code] = el;
                return acc;
            }, {}),
        [client],
    );

    const [excludedCodes, setExcludedCodes] = useState([]);
    const [data, setData] = useState({
        countries_localizations: {
            sv: {
                push_driver_id: null,
                push_driver_name: '',
                push_driver_key: '',
            },
            no: {
                push_driver_id: null,
                push_driver_name: '',
                push_driver_key: '',
            },
            fi: {
                push_driver_id: null,
                push_driver_name: '',
                push_driver_key: '',
            },
            da: {
                push_driver_id: null,
                push_driver_name: '',
                push_driver_key: '',
            },
            en: {
                push_driver_id: null,
                push_driver_name: '',
                push_driver_key: '',
            },
            is: {
                push_driver_id: null,
                push_driver_name: '',
                push_driver_key: '',
            },
        },
    });

    useEffect(() => {
        dispatch(getPushDrivers());
    }, [dispatch]);

    useEffect(() => {
        setData({
            countries_localizations: {
                sv: {
                    push_driver_id:
                        countriesLocalizationsData?.sv?.push_driver_id || null,
                    push_driver_name:
                        countriesLocalizationsData?.sv?.push_driver_name || '',
                    push_driver_key:
                        countriesLocalizationsData?.sv?.push_driver_key || '',
                },
                no: {
                    push_driver_id:
                        countriesLocalizationsData?.no?.push_driver_id || null,
                    push_driver_name:
                        countriesLocalizationsData?.no?.push_driver_name || '',
                    push_driver_key:
                        countriesLocalizationsData?.no?.push_driver_key || '',
                },
                fi: {
                    push_driver_id:
                        countriesLocalizationsData?.fi?.push_driver_id || null,
                    push_driver_name:
                        countriesLocalizationsData?.fi?.push_driver_name || '',
                    push_driver_key:
                        countriesLocalizationsData?.fi?.push_driver_key || '',
                },
                da: {
                    push_driver_id:
                        countriesLocalizationsData?.da?.push_driver_id || null,
                    push_driver_name:
                        countriesLocalizationsData?.da?.push_driver_name || '',
                    push_driver_key:
                        countriesLocalizationsData?.da?.push_driver_key || '',
                },
                en: {
                    push_driver_id:
                        countriesLocalizationsData?.en?.push_driver_id || null,
                    push_driver_name:
                        countriesLocalizationsData?.en?.push_driver_name || '',
                    push_driver_key:
                        countriesLocalizationsData?.en?.push_driver_key || '',
                },
                is: {
                    push_driver_id:
                        countriesLocalizationsData?.is?.push_driver_id || null,
                    push_driver_name:
                        countriesLocalizationsData?.is?.push_driver_name || '',
                    push_driver_key:
                        countriesLocalizationsData?.is?.push_driver_key || '',
                },
            },
        });
    }, [countriesLocalizationsData, client]);

    useEffect(() => {
        if (!!Object.keys(dataStore).length) {
            const excludedCodes = countriesOptions
                .filter(
                    (option) =>
                        !dataStore?.account_countries?.includes(option.id),
                )
                .map((item) => item.id.toLowerCase());

            setExcludedCodes(excludedCodes);
        }
    }, [dataStore]);

    const onChangeMultinational = (e, flag) => {
        const currentInput = e.target.id.slice(0, e.target.id.length - 3);
        const value = e.target.value;
        const newData = {
            ...data,
            countries_localizations: {
                ...data.countries_localizations,
                [flag]: {
                    ...data.countries_localizations[flag],
                    [currentInput]: value,
                },
            },
        };

        setData(newData);
    };

    const onSelectChange = (option, flag) => {
        const optionId = option.id;

        const newData = {
            ...data,
            countries_localizations: {
                ...data.countries_localizations,
                [flag]: {
                    ...data.countries_localizations[flag],
                    push_driver_id: optionId,
                    push_driver_name: '',
                    push_driver_key: '',
                },
            },
        };

        setData(newData);
    };

    const onSubmit = async (e) => {
        e.preventDefault();

        try {
            // await dispatch(
            //     updateClientDrivers({ id: params.id, body: data }),
            // ).unwrap();
            dispatch(getClient(params.id));
            toast.success('Changes saved successfully');
        } catch (error) {
            toast.error(error.errors);
        }
    };

    const selectOptions = pushDrivers?.reduce(
        (acc, el) => {
            acc.push({
                id: el.id,
                value: el.name.toLowerCase(),
                label: el.name,
            });
            return acc;
        },
        [
            {
                id: null,
                value: 'push_driver_id',
                label: 'Custom driver',
            },
        ],
    );

    return (
        <>
            <Helmet>
                <title>{`Console Defentry - Clients - ${client.name} - Notifications - Push`}</title>
            </Helmet>
            <Row>
                <Col span={10}>
                    <form>
                        <p className="form__input-group-header">
                            CURRENT DRIVER
                        </p>
                        <MultinationalTabs
                        codeType="countries"
                            excludedCodes={excludedCodes}
                        >
                            <PushTypeDriverInputs
                                onChange={onChangeMultinational}
                                onSelectChange={onSelectChange}
                                data={data.countries_localizations}
                                selectOptions={selectOptions}
                            />
                        </MultinationalTabs>
                        <div className="form__footer">
                            <button
                                className="modal__button modal__button-accept"
                                type="button"
                                onClick={onSubmit}
                            >
                                Save
                            </button>
                        </div>
                    </form>
                </Col>
            </Row>
        </>
    );
}
